//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import {mapGetters} from 'vuex';

export default {
  block: ['logoList'],
  props: ['data'],
  // computed: {
  //   ...mapGetters([
  //     'isMobile',
  //   ]),
  // },
}



// WEBPACK FOOTER //
// ./components/blocks/LogoList.vue